import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'MainFrame',
      meta: {
        title: 'Tracking',
        requireAuth: true,
      },
      component: () => import('@/views/MainFrame.vue'),
      redirect: '/Tracking',
      children: [
        // {
        //   path: '/Best', name: 'Best',
        //   meta: {
        //     title: 'Best',
        //     requireAuth: true,
        //   },
        //   component: () => import('@/views/Best.vue'),
        // },
        {
          path: '/Gift', name: 'Gift',
          meta: {
            title: 'GIFT',
            requireAuth: true,
          },
          component: () => import('@/views/Gift.vue'),
        },
        {
          path: '/GSKPDF', name: 'GSKPDF',
          meta: {
            title: 'GSKPDF',
            requireAuth: true,
          },
          component: () => import('@/views/other/GSKPDF.vue'),
        },
        {
          path: '/ZKDPDF', name: 'ZKDPDF',
          meta: {
            title: 'ZKDPDF',
            requireAuth: true,
          },
          component: () => import('@/views/other/ZKDPDF.vue'),
        },
        {
          path: '/OrdersUpload', name: 'OrdersUpload',
          meta: {
            title: 'OrdersUpload',
            requireAuth: true,
            roles: ['admin'],
          },
          component: () => import('@/views/OrdersUpload.vue'),
        },
        {
          path: '/DatabaseScreen', name: 'DatabaseScreen',
          meta: {
            title: 'DatabaseScreen',
            requireAuth: true,
          },
          component: () => import('@/views/DatabaseScreen.vue'),
        },
        {
          path: '/AddAsinInfo', name: 'AddAsinInfo',
          meta: {
            title: 'AddAsinInfo',
            requireAuth: true,
          },
          component: () => import('@/views/AddAsinInfo.vue'),
        },
        {
          path: '/AddAccount', name: 'AddAccount',
          meta: {
            title: 'AddAccount',
            requireAuth: true,
          },
          component: () => import('@/views/other/AddAccount.vue'),
        },
        {
          path: '/AddBrand', name: 'AddBrand',
          meta: {
            title: 'AddBrand',
            requireAuth: true,
          },
          component: () => import('@/views/other/AddBrand.vue'),
        },
        {
          path: '/Letter', name: 'Letter',
          meta: {
            title: 'Letter',
            requireAuth: true,
          },
          component: () => import('@/views/Letter.vue'),
        },
        {
          path: '/InspectSame', name: 'InspectSame',
          meta: {
            title: 'InspectSame',
            requireAuth: true,
          },
          component: () => import('@/views/InspectSame.vue'),
        },
        {
          path: '/LetterTrack', name: 'LetterTrack',
          meta: {
            title: 'LetterTrack',
            requireAuth: true,
          },
          component: () => import('@/views/LetterTrack.vue'),
        },
        {
          path: '/TemporaryOrdersUpload', name: 'TemporaryOrdersUpload',
          meta: {
            title: 'TemporaryOrdersUpload',
            requireAuth: true,
          },
          component: () => import('@/views/TemporaryOrdersUpload.vue'),
        },
        {
          path: '/SearchOrderID', name: 'SearchOrderID',
          meta: {
            title: 'SearchOrderID',
            requireAuth: true,
          },
          component: () => import('@/views/SearchOrderID.vue'),
        },
        {
          path: '/OrderDetails', name: 'OrderDetails',
          meta: {
            title: 'OrderDetails',
            requireAuth: true,
          },
          component: () => import('@/views/OrderDetails.vue'),
        },
        {
          path: '/AccountProfit', name: 'AccountProfit',
          meta: {
            title: 'AccountProfit',
            requireAuth: true,
          },
          component: () => import('@/views/profit/AccountProfit.vue'),
        },
        {
          path: '/AsinProfit', name: 'AsinProfit',
          meta: {
            title: 'AsinProfit',
            requireAuth: true,
          },
          component: () => import('@/views/profit/AsinProfit.vue'),
        },
        {
          path: '/ManageAsin', name: 'ManageAsin',
          meta: {
            title: 'ManageAsin',
            requireAuth: true,
          },
          component: () => import('@/views/ManageAsin.vue'),
        },
        {
          path: '/Tracking', name: 'Tracking',
          meta: {
            title: 'Tracking',
            requireAuth: true,
          },
          component: () => import('@/views/tracking/Tracking.vue'),
        },
        {
          path: '/EditorPMProduct', name: 'EditorPMProduct',
          meta: {
            title: 'EditorPMProduct',
            requireAuth: true,
          },
          component: () => import('@/views/tracking/EditorPMProduct.vue'),
        },
        {
          path: '/flow/ApplyPurchaseList', name: 'ApplyPurchaseList',
          meta: {
            title: 'ApplyPurchaseList',
            requireAuth: true,
          },
          component: () => import('@/views/flow/ApplyPurchaseList.vue'),
        },
        {
          path: '/flow/CreatePurchase', name: 'CreatePurchase',
          meta: {
            title: 'CreatePurchase',
            requireAuth: true,
          },
          component: () => import('@/views/flow/CreatePurchase.vue'),
        },
        {
          path: '/flow/PurchaseingList', name: 'PurchaseingList',
          meta: {
            title: 'PurchaseingList',
            requireAuth: true,
          },
          component: () => import('@/views/flow/PurchaseingList.vue'),
        },
        {
          path: '/flow/Purchaseing', name: 'Purchaseing',
          meta: {
            title: 'Purchaseing',
            requireAuth: true,
          },
          component: () => import('@/views/flow/Purchaseing.vue'),
        },
        {
          path: '/flow/BossPayList', name: 'BossPayList',
          meta: {
            title: 'BossPayList',
            requireAuth: true,
          },
          component: () => import('@/views/flow/BossPayList.vue'),
        },
        {
          path: '/flow/PayList', name: 'PayList',
          meta: {
            title: 'PayList',
            requireAuth: true,
          },
          component: () => import('@/views/flow/PayList.vue'),
        },
        {
          path: '/flow/GoodsList', name: 'GoodsList',
          meta: {
            title: 'GoodsList',
            requireAuth: true,
          },
          component: () => import('@/views/flow/GoodsList.vue'),
        },
        {
          path: '/other/qiniuyun', name: 'qiniuyun',
          meta: {
            title: 'qiniuyun',
            requireAuth: true,
          },
          component: () => import('@/views/other/qiniuyun.vue'),
        },
        {
          path: '/other/Test', name: 'Test',
          meta: {
            title: 'Test',
            requireAuth: true,
          },
          component: () => import('@/views/other/test.vue'),
        },
        {
          path: '/Fans/FansUpload', name: 'FansUpload',
          meta: {
            title: 'FansUpload',
            requireAuth: true,
          },
          component: () => import('@/views/other/FansUpload.vue'),
        },
        {
          path: '/official/WebsiteInfo', name: 'WebsiteInfo',
          meta: {
            title: 'WebsiteInfo',
            requireAuth: true,
          },
          component: () => import('@/views/officialWebsite/WebsiteInfo.vue'),
        },
        {
          path: '/official/DomainAsinInfo', name: 'DomainAsinInfo',
          meta: {
            title: 'DomainAsinInfo',
            requireAuth: true,
          },
          component: () => import('@/views/officialWebsite/DomainAsinInfo.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: (resolve) => require(['@/views/Login.vue'], resolve),
      component: () => import('@/views/Login.vue'),
    },
    {
      path: '/CheckOrder',
      name: 'CheckOrder',
      component: () => import('@/views/OutSide/CheckOrder.vue'),
    },
  ],
});
